module.exports = __webpack_public_path__ + "static/peach-payments-80cf18aaff6beaba344705b204181f0d.svg";